import React, { useState, useEffect } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import Select from "react-select";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";
import useAddCompatibilityModal from "pages/ProductCompatibility/components/AddCompatibilityModal/hooks/useAddCompatibilityModal";
import AddCompatibilityModal from "pages/ProductCompatibility/components/AddCompatibilityModal";
import Compatibility from "pages/ProductCompatibility/components/Compatibility";

const ProductCompatibility = () => {
  const [baseProduct, setBaseProduct] = useState({
    name: "",
    type: "physical",
    description: "",
    price: "",
    categories: [],
    availability: "available",
    weight: "",
  });
  const [compatibilities, setCompatibilities] = useState([]);
  const [groups, setGroups] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  let { _id } = useParams();
  const { showAddCompatibilityModal } = useAddCompatibilityModal();

  const getBaseProduct = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/base-products/${_id}`
      );
      if (response.status === 200) {
        const baseProduct = response.data.baseProduct;
        setBaseProduct(baseProduct);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const getCompatibilityCategories = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/base-products/${_id}/compatibility-categories`
      );
      if (response.status === 200) {
        const compatibilities = response.data.compatibilities;
        setCompatibilities(compatibilities);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const getGroups = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/groups?level=3`
      );
      if (response.status === 200) {
        const groups = response.data.groups;
        setGroups(groups);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const getCustomers = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/customers`
      );
      if (response.status === 200) {
        setCustomers(response.data.customers);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  useEffect(() => {
    getBaseProduct(); // eslint-disable-next-line react-hooks/exhaustive-deps
    getCompatibilityCategories(); // eslint-disable-next-line react-hooks/exhaustive-deps
    getGroups(); // eslint-disable-next-line react-hooks/exhaustive-deps
    getCustomers();
  }, []);

  const updateBaseProduct = async (key, update) => {
    try {
      const response = await axios.put(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/base-products/${_id}/${key}`,
        update
      );
    } catch (error) {
      console.log("error: ", error);
    }
  };

  useEffect(() => {
    const selectedGroupsIds = selectedGroups.map((group) => group._id);
    updateBaseProduct("groups", {
      groups: selectedGroupsIds,
    });
  }, [selectedGroups.length]);

  useEffect(() => {
    const selectedCustomerIds = selectedCustomers.map(
      (customer) => customer._id
    );
    updateBaseProduct("customers", {
      customers: selectedCustomerIds,
    });
  }, [selectedCustomers.length]);

  useEffect(() => {
    if (baseProduct.groups) {
      setSelectedGroups(baseProduct.groups);
    }
  }, [baseProduct.groups]);

  useEffect(() => {
    if (baseProduct.customers) {
      setSelectedCustomers(baseProduct.customers);
    }
  }, [baseProduct.customers]);

  const getGroupFromId = (groupId, groups) => {
    const group = groups.find((group) => group._id === groupId);
    return group;
  };

  const getCustomerFromId = (customerId, customers) => {
    const customer = customers.find((customer) => customer._id === customerId);
    return customer;
  };

  return (
    <div style={{ padding: "40px" }}>
      <Row>
        <Col>
          <div>
            <h1>Product Compatibility</h1>
            <div style={{ fontWeight: "bold" }}>
              <p>SKU: {baseProduct.sku}</p>
              <p>{baseProduct.name}</p>
            </div>
            {baseProduct.id != null && (
              <p style={{ fontSize: 14, marginTop: 12, maxWidth: 560 }}>
                Marketing categories and hardware specs:{" "}
                <Link to={`/admin/products/${baseProduct.id}`}>
                  edit on the catalog product page
                </Link>{" "}
                (this product is a base product).
              </p>
            )}
          </div>
          <hr
            style={{
              width: "100%",
              textAlign: "left",
              marginLeft: "0",
            }}
          ></hr>
        </Col>
      </Row>

      <Form.Group controlId="customers">
        <Form.Label>For Customers</Form.Label>
        {/* <p>
          If empty, it will show on the Server Builds website. If set, it will
          only show on customers selected.
        </p> */}
        <Select
          options={customers.map((customer) => ({
            value: customer._id,
            label: customer.name,
          }))}
          isMulti={true}
          closeMenuOnSelect={true}
          onChange={(e) => {
            setSelectedCustomers(
              e.map((customer) => getCustomerFromId(customer.value, customers))
            );
          }}
          value={selectedCustomers.map((customer) => ({
            value: customer._id,
            label: customer.name,
          }))}
          name="customers"
        />
      </Form.Group>

      <Form.Group controlId="groups" size="lg">
        <Form.Label>Groups</Form.Label>
        <Select
          options={groups.map((group) => ({
            value: group._id,
            label: group.name,
          }))}
          isMulti={true}
          closeMenuOnSelect={true}
          onChange={(e) => {
            setSelectedGroups(
              e.map((group) => getGroupFromId(group.value, groups))
            );
          }}
          value={selectedGroups.map((group) => ({
            value: group._id,
            label: group.name,
          }))}
          name="groups"
        />
      </Form.Group>

      <Row>
        <Col>
          {compatibilities.map((compatibility) => (
            <Compatibility
              key={compatibility?.compatibility?._id}
              baseProductId={_id}
              compatibilityId={compatibility?.compatibility?._id}
              onDeletedCompatibility={getCompatibilityCategories}
            />
          ))}
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            onClick={() => {
              showAddCompatibilityModal();
            }}
            style={{ marginTop: "20px" }}
          >
            Add Compatibility
          </Button>
          <AddCompatibilityModal
            baseProductId={_id}
            onAddedCompatibility={getCompatibilityCategories}
            compatibilities={compatibilities}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ProductCompatibility;
